import React from 'react'
import { Card } from 'antd'
import { useSelector } from 'react-redux'
import { isNumber } from 'lodash'
import RubricsTable from './list/RubricsTable'
import RubricDrawer from './drawer/RubricDrawer'
import CreateRubricButton from './list/CreateRubricButton'
import rubricSelectors from '../../../../store/selectors/rubric.selectors'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'
import assignmentSelectors from '../../../../store/selectors/assignment.selectors'
import Access from '../../components/access/Access'
import { TextContentRules } from '../../components/access/access-rules/assignment-rules'
import { State } from '../../../../constants/assignment-permissions'

const RubricsManagementSection = () => {
    const assignmentName = useSelector(assignmentSelectors.name)
    useDocumentTitle(`${assignmentName || ''} Rubrics`)
    
    const editingRubricId = useSelector(rubricSelectors.editingRubricId)
    const showCreateRubricDrawer = useSelector(rubricSelectors.showCreateRubricDrawer)

    return (
        <Card
            title='Rubrics'
            extra={
                <Access rules={[...TextContentRules.EDIT_GRADINGS, State.NO_SUBMISSIONS]}>
                    <CreateRubricButton />
                </Access>
            }
        >
            <RubricsTable />
            {(isNumber(editingRubricId) || showCreateRubricDrawer) && <RubricDrawer />}
        </Card>
    )
}

export default RubricsManagementSection
